import { Button, Stack } from "@mui/material";
import Iconify from "../../minimals/components/iconify";
import OrderAddress from "../shared/orderInfo/OrderAndAddress";

interface IProps {
  handleOpenNewRecordable: () => void;
  handleOpenPrintBarcodes: () => void;
  isReorderMode: boolean;
}

export default function RecordableHeader({
  handleOpenNewRecordable,
  handleOpenPrintBarcodes,
  isReorderMode
}: IProps) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <OrderAddress />
      <Stack direction="row" spacing={1}>
        <Button
          color="primary"
          variant="outlined"
          endIcon={<Iconify icon="mdi:barcode-scan" />}
          onClick={handleOpenPrintBarcodes}
          disabled={isReorderMode}
        >
          Generate QR Codes
        </Button>
        <Button
          color="primary"
          variant="contained"
          startIcon={<Iconify icon="eva:plus-fill" />}
          onClick={handleOpenNewRecordable}
          disabled={isReorderMode}
        >
          New Recordable
        </Button>
      </Stack>
    </Stack>
  );
}
